import { createStore } from "jotai";

export const atomsStore = createStore();
